import DashboardNavbar from "../../../components/Navbars/DashboardNavbar";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import Grid from "@mui/material/Grid";
import Footer from "../../../components/Footer";
import usePayoutDetails from "./usePayoutDetails";
import DashboardLayout from "../../../components/LayoutContainers/DashboardLayout";
import bgImage from "assets/images/bg_doctor.jpg";
import {APP_URL, COLOR_SECONDARY} from "../../../config";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import React from "react";
import PersonAddIcon from '@mui/icons-material/PersonAddOutlined';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacyOutlined';
import AccountBalanceIcon from '@mui/icons-material/AccountBalanceOutlined';
import AttachMoneyIcon from '@mui/icons-material/AttachMoneyOutlined';
import AccessTimeIcon from '@mui/icons-material/AccessTimeOutlined';
import Sales from "./components/Sales/Sales";
import MDButton from "../../../components/MDButton";
import RequestPageIcon from "@mui/icons-material/RequestPage";

const PayoutDetails = () => {

    const {id, payout, isLoading, renderStatusChip} = usePayoutDetails();

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={2}>
                {
                    isLoading ?
                        <MDBox mt={2} mx={2} p={10} display="flex" justifyContent="center"
                               alignItems="center">
                            <CircularProgress color="secondary" style={{overflow: 'hidden'}}/>
                        </MDBox> :
                        <>
                            <Grid container justifyContent="center">
                                <Grid item xs={12} lg={12}>
                                    <Card>
                                        <MDBox p={4}>
                                            <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start'}}>
                                                <MDBox>
                                                    <MDTypography variant="h4">ID del pago: #POT-{payout.id}</MDTypography>
                                                    <MDTypography variant="subtitle2">{payout.created_at}</MDTypography>
                                                </MDBox>
                                                <MDBox ml={1}>
                                                    {
                                                        renderStatusChip(payout.status)
                                                    }
                                                </MDBox>
                                            </MDBox>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} lg={9}>
                                                    <Sales id={id} />
                                                </Grid>
                                                <Grid item xs={12} lg={3}>
                                                    <MDBox mb={2} mt={2} sx={{padding: 2, borderStyle: 'solid', borderWidth: 1, borderColor: '#e2e2e2', borderRadius: 2}}>
                                                        <MDTypography variant="h6" sx={{marginBottom: 2}}>Información</MDTypography>
                                                        <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                            <PersonAddIcon></PersonAddIcon>
                                                            <MDTypography variant="body2" sx={{marginLeft: 1, fontSize: 16}}>{payout.doctor.name}</MDTypography>
                                                        </MDBox>
                                                        <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 1}}>
                                                            <AttachMoneyIcon></AttachMoneyIcon>
                                                            <MDTypography variant="body2" sx={{marginLeft: 1, fontSize: 16}}>${payout.total}</MDTypography>
                                                        </MDBox>
                                                        {
                                                            payout.paid_at !== null &&
                                                            <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 1}}>
                                                                <AccessTimeIcon></AccessTimeIcon>
                                                                <MDTypography variant="body2" sx={{marginLeft: 1, fontSize: 16}}>{payout.paid_at}</MDTypography>
                                                            </MDBox>
                                                        }
                                                        {
                                                            payout.bank_account !== null &&
                                                            <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 1}}>
                                                                <AccountBalanceIcon></AccountBalanceIcon>
                                                                <MDTypography variant="body2" sx={{marginLeft: 1, fontSize: 16}}>{payout.bank_account}</MDTypography>
                                                            </MDBox>
                                                        }
                                                    </MDBox>
                                                    <MDButton color="secondary" disabled={payout.voucher === null} fullWidth onClick={() => window.open(`${APP_URL}/storage/vouchers/${payout.voucher}`, "_blank")}>VER COMPROBANTE</MDButton>
                                                </Grid>
                                            </Grid>
                                        </MDBox>
                                    </Card>
                                </Grid>
                            </Grid>
                        </>
                }
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default PayoutDetails;
